import JSONAPIClient from '../JSONAPIClient'

JSONAPIClient.define('loan_officer', {
  name: '',
  team_id: '',
  slug: '',
  encompass_active: false,
  lqb_active: false,
})
